var map = {
	"./1.jpg": 4330,
	"./10.jpg": 2483,
	"./11.jpg": 6327,
	"./12.jpg": 5822,
	"./13.jpg": 1051,
	"./14.jpg": 5386,
	"./15.jpg": 8932,
	"./16.jpg": 4243,
	"./17.jpg": 6470,
	"./18.jpg": 4404,
	"./19.jpg": 6734,
	"./1Garudotsavam3.jpg": 4389,
	"./2.jpg": 9983,
	"./3.jpg": 1974,
	"./4.jpg": 4005,
	"./5.jpg": 8935,
	"./6.jpg": 5106,
	"./7.jpg": 6343,
	"./8.jpg": 6383,
	"./9.jpg": 8503,
	"./Karva Chauth Pooja 3.jpg": 1449,
	"./SriBalajiAbhisheka_SYHCS_2023_0519_Original.jpg": 3552,
	"./WhatsApp Image 2025-07-12 at 14.28.39 (1).jpeg": 6620,
	"./WhatsApp Image 2025-07-12 at 14.28.39 (3).jpeg": 3025,
	"./WhatsApp Image 2025-07-12 at 14.28.39.jpeg": 4830,
	"./WhatsApp Image 2025-07-12 at 14.29.37 (1).jpeg": 3714,
	"./WhatsApp Image 2025-07-12 at 14.29.37 (5).jpeg": 1928,
	"./WhatsApp Image 2025-07-12 at 14.29.38 (1).jpeg": 7815,
	"./WhatsApp Image 2025-07-12 at 14.29.38 (2).jpeg": 9097,
	"./WhatsApp Image 2025-07-12 at 14.29.38.jpeg": 8214
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 476;